import { Injectable } from '@angular/core';
import {SucursalDTO} from "../../dtos/sucursal.dto";


@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  getSucursalesSeleccionadas() {
    return JSON.parse(localStorage.getItem('SUCURSALES_SELECCIONADAS')) || [];
  }

  setSucursalesSeleccionadas(sucursales: Array<SucursalDTO>) {
    localStorage.setItem('SUCURSALES_SELECCIONADAS', JSON.stringify(sucursales));
  }

  getTodasSucursalesSeleccionadas(): boolean {
    return JSON.parse(localStorage.getItem('SUCURSALES_TODAS_SELECCIONADAS')) === true;
  }

  setTodasSucursalesSeleccionadas(todas: boolean) {
    localStorage.setItem('SUCURSALES_TODAS_SELECCIONADAS', JSON.stringify(todas));
  }



}
